import {AggregationType} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/TeleportPropertyTypeStrategy/enum/AggregationType'

export function shouldGetDisplayValueByAggregationType(aggregationtype: AggregationType): boolean {
  const typesThatNeedGetDispayValue = [
    AggregationType.NumberSum,
    AggregationType.NumberAverage,
    AggregationType.NumberMedian,
    AggregationType.NumberMin,
    AggregationType.NumberMax,
    AggregationType.NumberRange,
    AggregationType.TimeTrackerSum,
  ]

  return typesThatNeedGetDispayValue.includes(aggregationtype)
}
